const { name } = require('./package');
const { default: Axios } = require("axios");

const fs = require("fs")
const path = require("path")
const packageJson = require("./package.json")

const getAppVersion = () => {
  const envName = process.env.VUE_APP_ENV
  const baseVersion = packageJson.version
  const timestamp = new Date().toISOString().slice(0, 16).replace(/[-T:]/g, "")
  return `${envName}-${baseVersion}-${timestamp}`
}

const buildVersion = getAppVersion()

const timestamp = new Date().getTime();
const target = process.env.VUE_APP_API_URL; // 服务器地址 正式
// const imgUrlTarget = 'https://testdev.scxinglin.com' //静态资源地址 测试
const imgUrlTarget = process.env.VUE_APP_RESOURCE_URL //静态资源地址 测试
const xlTarget = process.env.VUE_APP_XL_API_URL
const printTarget = process.env.VUE_APP_PRINT_URL

module.exports = {
  // baseUrl: "./",
  // publicPath: process.env.NODE_ENV === 'production' ? '/system/his_system/' : '/',
  devServer: {
		onListening(server) {
			server.listeningApp.setMaxListeners(20);
		},
		headers: {
			'Access-Control-Allow-Origin': '*',
		},
    proxy: {
      // 设置本地跨域代理 --- 用于社保程序调用
			'/shebaoUrl': {
				target: 'http://127.0.0.1:8802', // 服务器地址
				changeOrigin: true, // 跨域
				pathRewrite: {
					'/shebaoUrl': ''
				}
			},
			// 设置远程跨域代理 --- 用于远程接口调用
			'/api': {
				target: target,
				changeOrigin: true, // 跨域
			},
			'/systemTime': {
				target: target,
				changeOrigin: true, // 跨域
			},
			// 医生引进
			'/cluepool': {
				target: target,
				changeOrigin: true,
			},
			'/version': {
				target: target,
				changeOrigin: true, // 跨域
			},
			'/st': {
				target: target,
				changeOrigin: true, // 跨域
			},
			// 设置远程跨域代理 --- 用于远程资源请求
			'/fileUrl': {
				target: target,
				changeOrigin: true, // 跨域
				pathRewrite: {
					'/fileUrl': ''
				}
			},
			'/imgUrl': {
				target: imgUrlTarget,
				changeOrigin: true, // 跨域
				pathRewrite: {
					'/imgUrl': ''
				}
			},
			'/xl': {
				target: xlTarget,
				changeOrigin: true, // 跨域
				pathRewrite: {
					'/xl': ''
				}
			},
			'/voiceUrl':{
				target: 'http://127.0.0.1:8702', // 服务器地址
				changeOrigin: true, // 跨域
				pathRewrite: {
					'/voiceUrl': ''
				}
			},
			'/printUrl':{
				target: printTarget, // 服务器地址
				changeOrigin: true, // 跨域
				pathRewrite: {
					'/printUrl': ''
				}
			}
    },
  },
	configureWebpack: {
		output: {
			filename: `js/[name].${timestamp}.js`,
			chunkFilename: `js/[id].${timestamp}.js`,
			library: `${name}-[name]`,
			libraryTarget: 'umd',
			jsonpFunction: `webpackJsonp_${name}`
		}
	},
	chainWebpack: config => {
		config.module
			.rule('fonts')
			.test(/.(ttf|otf|eot|woff|woff2)$/)
			.use('url-loader')
			.loader('url-loader')
			.tap(options => {
				options = {
					name: '/static/fonts/[name].[ext]'
				}
				return options
			})

		config.plugin('define').tap(definitions => {
			definitions[0]['process.env']['VUE_APP_VERSION'] = JSON.stringify(buildVersion)
			return definitions
		})

		if (process.env.NODE_ENV !== 'development') {
			config.plugin("after-emit-plugin").use({
				apply(compiler) {
          compiler.hooks.afterEmit.tapAsync("AfterEmitPlugin", (compilation, callback) => {
						// 生成你的 JSON 数据
            const data = {
              code: 200,
							data: {
								version: buildVersion,
								silence: JSON.parse(process.env.VUE_APP_SILENCE),
								timestamp: new Date().toISOString()
							},
							msg: '操作成功'
            }
            // 输出目录
            const outputPath = compilation.outputOptions.path
            
            // 写入文件
            fs.writeFileSync(
              path.join(outputPath, 'version.json'),
              JSON.stringify(data, null, 2)
            )

            callback()
          })
        }
			})
		}
	},
	css: {
		extract: {
			filename: `css/[name].${timestamp}.css`,
			chunkFilename: `css/[name].${timestamp}.css`
		}
	}
}